/* eslint-disable import/order */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useCountDown } from 'utils/hooks/useCountDown';
import { DISCOUNTS } from '../utils/constants';
import evieLogo from 'assets/images/index-logo.webp';

import SolidButton from 'components/SolidButton';

const HeaderIndex = ({ isDiscount, identifier }) => {
  const { t } = useTranslation();
  const offeringsNode = document.getElementById('offerings');

  const { minutes, seconds } = useCountDown({ deadline: 900000 });

  const handleScrollToNode = () => {
    if (offeringsNode) {
      offeringsNode.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`index-screen__header ${isDiscount ? 'discount' : ''}`}>
      <img src={evieLogo} alt="Evie Logo" className="index-screen__header_logo" />
      <SolidButton className="evie-index pulse-button" onClick={handleScrollToNode}>
        {t('evieOnboarding.indexScreen.header.btn')}
      </SolidButton>
      {isDiscount ? (
        <div className="index-screen__offerbanner">
          <p className="index-screen__offerbanner_percentage">
            {t('evieOnboarding.indexScreen.banner.percentage')} {100 - DISCOUNTS[identifier]}%
          </p>
          <p className="index-screen__offerbanner_deadline">
            {t('evieOnboarding.indexScreen.banner.deadline')}{' '}
            <strong>
              {minutes}:{seconds}
            </strong>
          </p>
        </div>
      ) : null}
      {/* <div className={`index-screen__header_blurbg ${isDiscount ? 'discount' : ''}`} /> */}
    </header>
  );
};

HeaderIndex.defaultProps = { isDiscount: false, identifier: null };

HeaderIndex.propTypes = { isDiscount: PropTypes.bool, identifier: PropTypes.string };

export default HeaderIndex;
